import Handsontable from 'handsontable';
import { CellSelections } from '../../../../../common/table/TableTypes';

type ActiveTableState = Handsontable | undefined;

export const selectActiveTableCellSelection = (activeTableState: ActiveTableState): CellSelections | undefined =>
    activeTableState?.getSelected();
